import { useUiStore } from "@/shared/stores/uiStore";
import { TokenModal } from "@/widgets/TokenModal";
import { InviteModal } from "@/widgets/InviteModal";
import { CopyErrorModal } from "@/shared/ui/CopyErrorModal/CopyErrorModal";
import { ConfirmationModal } from "@/shared/ui/ConfirmationModal/ConfirmationModal";
import { UnsubscribeFlowModal } from "@/widgets/UnsubscribeFlowModal";
import { AdminSwitchUserForm } from "../AdminSwitchUserForm";
import { TopUpBalanceModal } from "../TopUpBalanceModal";
import { useSuppliersStore } from "@/shared/stores/suppliersStore";
import { type ModalProps } from "@/shared/stores/uiStore";

export function GlobalModals() {
  const { activeModal, modalProps, closeModal, updateModalProps } =
    useUiStore();
  const { suppliers, fetchSuppliers } = useSuppliersStore();

  if (!activeModal) {
    return null;
  }

  const commonProps = {
    isOpen: true,
    onClose: closeModal,
  };

  switch (activeModal) {
    case "TOKEN": {
      const props = modalProps as ModalProps["TOKEN"];
      return (
        <TokenModal
          {...commonProps}
          suppliers={suppliers}
          refetchSuppliers={fetchSuppliers}
          onTokenAdded={props.onTokenAdded || null}
        />
      );
    }
    case "COPY_ERROR": {
      const props = modalProps as ModalProps["COPY_ERROR"];
      return <CopyErrorModal {...commonProps} textToCopy={props.textToCopy} />;
    }
    case "CONFIRMATION": {
      const props = modalProps as ModalProps["CONFIRMATION"];
      const handleConfirm = async () => {
        updateModalProps({ isLoading: true });
        await props.onConfirm();
      };
      return (
        <ConfirmationModal
          {...commonProps}
          onConfirm={handleConfirm}
          message={props.message}
          isLoading={props.isLoading || false}
        />
      );
    }
    case "UNSUBSCRIBE_FLOW": {
      const props = modalProps as ModalProps["UNSUBSCRIBE_FLOW"];
      const handleConfirm = async (
        feedback: { question: string; answer: string }[],
      ) => {
        updateModalProps({ isLoading: true });
        try {
          await props.onConfirm(feedback);
        } catch (error) {
          // Без сброса флага кнопка навсегда остаётся спиннером и повторить
          // отмену уже нечем — окно приходится закрывать и вводить всё заново.
          updateModalProps({ isLoading: false });
          throw error;
        }
      };
      return (
        <UnsubscribeFlowModal
          {...commonProps}
          onConfirm={handleConfirm}
          isLoading={props.isLoading || false}
        />
      );
    }
    case "INVITE":
      return <InviteModal {...commonProps} />;

    case "ADMIN_SWITCH_USER":
      return <AdminSwitchUserForm {...commonProps} />;

    case "TOP_UP_BALANCE": {
      const props = modalProps as ModalProps["TOP_UP_BALANCE"];
      return <TopUpBalanceModal {...commonProps} {...props} />;
    }

    default:
      return null;
  }
}
